import { NewspaperIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@library/components/tooltip/Tooltip';

export interface SimIndicatorProps {
  isSimulation: boolean;
  className?: string;
}

export const SimIndicator = ({
  isSimulation,
  className = ''
}: SimIndicatorProps) => {
  if (!isSimulation) {
    return null;
  }

  return (
    <Tooltip
      title="Source: Simulation"
      text="This projection value was generated by a simulation"
    >
      <NewspaperIcon className={className} />;
    </Tooltip>
  );
};
